export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/smoke.d0214815.gif","height":800,"width":336,"blurWidth":0,"blurHeight":0};